import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface ApplePaginatorEvent {
  pageIndex: number;
  pageSize: number;
  length: number;
}

@Component({
  selector: 'apple-paginator',
  templateUrl: './apple-paginator.component.html',
  styleUrls: ['./apple-paginator.component.scss'],
  standalone: false,
})
export class ApplePaginatorComponent {
  @Input() length: number = 0;
  @Input() pageSize: number = 10;
  @Input() pageIndex: number = 0;
  @Input() pageSizeOptions: number[] = [5, 10, 20, 40];
  
  @Output() page = new EventEmitter<ApplePaginatorEvent>();
  
  public get pageSizeOptionsStrings(): string[] {
    return this.pageSizeOptions.map(size => size.toString());
  }
  
  public onPageSizeChange(value: string): void {
    const size = parseInt(value, 10);
    
    if (size !== this.pageSize) {
      this.pageSize = size;
      this.pageIndex = 0; // Reset to first page when changing page size
      this.emitPageEvent();
    }
  }

  public previousPage(): void {
    if (this.hasPreviousPage()) {
      this.pageIndex--;
      this.emitPageEvent();
    }
  }

  public nextPage(): void {
    if (this.hasNextPage()) {
      this.pageIndex++;
      this.emitPageEvent();
    }
  }

  public hasPreviousPage(): boolean {
    return this.pageIndex > 0;
  }

  public hasNextPage(): boolean {
    const maxPageIndex = Math.ceil(this.length / this.pageSize) - 1;
    return this.pageIndex < maxPageIndex;
  }

  public getRangeLabel(): string {
    if (this.length === 0) {
      return '0 van 0';
    }

    const startIndex = this.pageIndex * this.pageSize + 1;
    const endIndex = Math.min((this.pageIndex + 1) * this.pageSize, this.length);
    
    return `${startIndex} - ${endIndex} van ${this.length}`;
  }

  private emitPageEvent(): void {
    this.page.emit({
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      length: this.length
    });
  }

}
